import { useEffect, useState } from "react";
import { tours as seedTours } from "./mock";
import { api } from "./api";

/**
 * useTours — returns the seed tour list merged with admin-editable overrides
 * from the backend. Falls back cleanly if the backend is unreachable.
 */
export function useTours() {
  const [tours, setTours] = useState(seedTours);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/tours/overrides");
        if (cancelled) return;
        if (!Array.isArray(data) || data.length === 0) {
          setTours(seedTours);
        } else {
          const byId = Object.fromEntries(data.map((d) => [d.id, d]));
          setTours(seedTours.map((t) => byId[t.id] ? { ...t, ...byId[t.id] } : t));
        }
      } catch {
        setTours(seedTours);
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { tours, ready };
}

/** Find one tour by id (uses live merged data). */
export function useTour(id) {
  const { tours, ready } = useTours();
  return { tour: tours.find((t) => t.id === id), ready };
}
